var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && !_vm.user.email_verified_at)?_c('div',{staticClass:"alert alert-warning",staticStyle:{"position":"relative","top":"60px"},attrs:{"id":"validation-message"}},[_c('fa',{staticClass:"ml-4",attrs:{"icon":"exclamation"}}),_c('span',[_vm._v("يرجى التحقق من البريد الإلكتروني لتتمكن من الاستفادة من الموقع.")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }